// Utility functions for carrier management

// Group carriers by name for cleaner display
export function groupCarriersByName(carriers) {
  const grouped = {};
  
  carriers.forEach(carrier => {
    // Try different possible name properties (Name, name, CarrierName, etc.)
    const name = carrier.Name || carrier.name || carrier.CarrierName || carrier.carrierName || `Carrier ${carrier.CarrierId}`;
    
    if (!grouped[name]) {
      grouped[name] = {
        name: name,
        carrierIds: []
      };
    }
    grouped[name].carrierIds.push(carrier.CarrierId);
  });
  
  return Object.values(grouped);
}

// Convert grouped carriers back to original format
export function ungroupCarriers(groupedCarriers, allCarriers) {
  const result = [];
  
  groupedCarriers.forEach(group => {
    group.carrierIds.forEach(carrierId => {
      const carrier = allCarriers.find(c => c.CarrierId === carrierId);
      if (carrier) {
        result.push(carrier);
      }
    });
  });
  
  return result;
}

// Compress carrier data to only IDs to reduce payload size
export function compressCarrierData(statesWithCarriers) {
  if (!statesWithCarriers) return {};
  
  const compressed = {};
  Object.entries(statesWithCarriers).forEach(([state, carriers]) => {
    compressed[state] = carriers.map(c => c.CarrierId || c);
  });
  return compressed;
}

// Decompress carrier data from IDs back to full objects
export function decompressCarrierData(statesWithCarriers, allCarriers) {
  if (!statesWithCarriers || !allCarriers) return {};
  
  const decompressed = {};
  Object.entries(statesWithCarriers).forEach(([state, carrierIds]) => {
    decompressed[state] = carrierIds
      .map(id => allCarriers.find(c => c.CarrierId === id))
      .filter(Boolean);
  });
  return decompressed;
}
